/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FilterOption
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Vehicles Bought Via Filters
 */
export const vehicleBoughtViaFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/vehicles/bought-via`, method: 'GET', signal
    },
      );
    }




export const getVehicleBoughtViaFiltersQueryKey = () => {
    return [
    'filters','vehicles','bought-via'
    ] as const;
    }


export const getVehicleBoughtViaFiltersQueryOptions = <TData = Awaited<ReturnType<typeof vehicleBoughtViaFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleBoughtViaFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleBoughtViaFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleBoughtViaFilters>>> = ({ signal }) => vehicleBoughtViaFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleBoughtViaFilters>>, TError, TData>
}

export type VehicleBoughtViaFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleBoughtViaFilters>>>
export type VehicleBoughtViaFiltersQueryError = ErrorType<unknown>


/**
 * @summary Vehicles Bought Via Filters
 */

export function useVehicleBoughtViaFilters<TData = Awaited<ReturnType<typeof vehicleBoughtViaFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleBoughtViaFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleBoughtViaFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






